export default "__VITE_PUBLIC_ASSET__938858ad__"